export default "__VITE_ASSET__WOkcmzdg__"